import { type ReactElement } from 'react';

export function RouterLoadingFallback(): ReactElement {
  return (
    <div className="flex h-screen w-screen items-center justify-center bg-slate-50">
      <div className="h-8 w-8 animate-spin rounded-full border-4 border-[#05BFA0] border-t-transparent" />
    </div>
  );
}
